import React from 'react'
import AdminHome from '../../Components/admin/AdminHome/AdminHome'

const AdminHomePage = () => {
  return (
    <div>
        <AdminHome/>
    </div>
  )
}

export default AdminHomePage